<template>
    <button v-if="visible" class="btn btn-flat" :class="btnClasses" :style="styleObj"
    @click.prevent="exec(execParam)">
        <i v-if="icon!=null" :class="icon" style="margin-left: 0px;"></i>
    </button>
</template>

<script>
export default {
  name: "Buttons",
  props: {
    configs: {
      type: Object,
      default: function() {
        return {
          ID: null
        };
      }
    },
    //funzione eseguita all'onclick
    exec: {
      type: Function,
      default() {
        //console.log(this.configs.ID + " clicked");
      }
    },
    //parametro da passare alla funzione exec (facoltativo)
    execParam: {
      type: String,
      default: null
    },
    // stile inline applicato a button
    styleObj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    //classi css applicate a button (aggiunte a btn e btn-flat)
    btnClasses: {
      type: String,
      default: null
    },
    //classe icona opzionale da mostrare all'interno di button ('es font awesome: fa fa-sitemap')
    icon: {
      type: String,
      default: null
    }
  },
  mounted: function() {
    if (this.configs.ID != null) {
      this.init();
    }
  },
  data: function() {
    return {
      visible: false
    };
  },
  methods: {
    init: function() {
      var merged_c = this.configs;
      this.visible = merged_c.visible;

      // se il pulsante non è visibile, lo segnalo al genitore (che eventualmente si può adattare)
      if (!this.visible) {
        this.$emit("invisible");
      }
    }
  }
};
</script>

<style scoped>
.btn-flat {
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/DynButton.vue?f6770cb6